/* eslint-disable no-unused-vars */
import React from "react";
import OnboardHeading from "../../components/OnboardHeading";
import { getRevertUser } from "../../api";
import { Col } from "react-bootstrap";
import RevertButtonComp from "../../components/revertButton";
import "./style.scss";

const TitleCard = ({
  month,
  dayWithSuffix,
  dayOfWeek,
  currentTime,
  isReseller,
}) => {
  return (
    <div className="header-container">
      <div className="header-card">
        <div className="header-content">
          <OnboardHeading
            title="reseller dashboard"
            subtitle={
              <>
                Welcome to your dashboard!{" "}
                <a
                  href="https://help.support.guhroo.co/portal/en/kb/guhroo"
                  className="link-color"
                  target="_blank"
                  rel="noreferrer"
                >
                  View Knowledge Base
                </a>{" "}
              </>
            }
            upperCaseTitle={true}
          />
        </div>
        <div className="profile-time-card">
          <div className="profile-icon">
            {/* <img src={timer} alt="profile-icon" /> */}
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_779_119"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="36"
                height="36"
              >
                <rect width="36" height="36" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_779_119)">
                <path
                  d="M17.7 24.3L19.8 22.2L15 17.4V10.5H12V18.6L17.7 24.3ZM27 30.75V27.45C28.85 26.575 30.3125 25.2875 31.3875 23.5875C32.4625 21.8875 33 20.025 33 18C33 15.975 32.4625 14.1125 31.3875 12.4125C30.3125 10.7125 28.85 9.425 27 8.55V5.25C29.725 6.2 31.9063 7.84375 33.5438 10.1813C35.1813 12.5188 36 15.125 36 18C36 20.875 35.1813 23.4813 33.5438 25.8188C31.9063 28.1562 29.725 29.8 27 30.75ZM13.5 31.5C11.625 31.5 9.86875 31.1438 8.23125 30.4313C6.59375 29.7188 5.16875 28.7563 3.95625 27.5438C2.74375 26.3313 1.78125 24.9062 1.06875 23.2687C0.35625 21.6313 0 19.875 0 18C0 16.125 0.35625 14.3688 1.06875 12.7313C1.78125 11.0938 2.74375 9.66875 3.95625 8.45625C5.16875 7.24375 6.59375 6.28125 8.23125 5.56875C9.86875 4.85625 11.625 4.5 13.5 4.5C15.375 4.5 17.1313 4.85625 18.7687 5.56875C20.4062 6.28125 21.8313 7.24375 23.0438 8.45625C24.2563 9.66875 25.2188 11.0938 25.9313 12.7313C26.6438 14.3688 27 16.125 27 18C27 19.875 26.6438 21.6313 25.9313 23.2687C25.2188 24.9062 24.2563 26.3313 23.0438 27.5438C21.8313 28.7563 20.4062 29.7188 18.7687 30.4313C17.1313 31.1438 15.375 31.5 13.5 31.5ZM13.5 28.5C16.425 28.5 18.9062 27.4813 20.9438 25.4438C22.9813 23.4062 24 20.925 24 18C24 15.075 22.9813 12.5938 20.9438 10.5562C18.9062 8.51875 16.425 7.5 13.5 7.5C10.575 7.5 8.09375 8.51875 6.05625 10.5562C4.01875 12.5938 3 15.075 3 18C3 20.925 4.01875 23.4062 6.05625 25.4438C8.09375 27.4813 10.575 28.5 13.5 28.5Z"
                  fill="#564AA3"
                />
              </g>
            </svg>
          </div>
          <div className="date-time">
            <span className="date">
              {month} {dayWithSuffix}
            </span>
            <span className="time">
              {dayOfWeek?.toUpperCase()}, {currentTime}
            </span>
          </div>
        </div>

        {getRevertUser() ? (
          <>
            {!isReseller && (
              <Col
                md={12}
                // sm={getRevertUser() ? 4 : 2}
                className="d-flex align-items-center justify-content-end mb-4"
              >
                <RevertButtonComp />
              </Col>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default TitleCard;
